import React from 'react';

import COLORS from '../../../constants/colors.constants';

const TrashFillIcon = ({
  width = 12,
  height = 14,
  fill = COLORS.brand,
}) => (
  <svg width={width} height={height} viewBox="0 0 12 14">
    <path d="M11.2383 0.988281V2.5H0.761719V0.988281H3.36328L4.13672 0.25H7.86328L8.63672 0.988281H11.2383ZM1.5 12.2383V3.23828H10.5V12.2383C10.5 12.6602 10.3242 13.0117 10.043 13.293C9.72656 13.6094 9.375 13.75 8.98828 13.75H3.01172C2.58984 13.75 2.23828 13.6094 1.95703 13.293C1.64062 13.0117 1.5 12.6602 1.5 12.2383Z" fill={fill}/>
  </svg>
)

export default TrashFillIcon;
